import { render } from "./MfaTel.vue?vue&type=template&id=047be258&scoped=true"
import script from "./MfaTel.vue?vue&type=script&lang=js"
export * from "./MfaTel.vue?vue&type=script&lang=js"

import "./MfaTel.vue?vue&type=style&index=0&id=047be258&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047be258"]])

export default __exports__